// extracted by mini-css-extract-plugin
var _1 = "ProfileUserInfoItemCard-modulecard__V4sdh";
var _2 = "ProfileUserInfoItemCard-modulecontacts__fz7ty";
var _3 = "ProfileUserInfoItemCard-moduledivider__EK8Ai Divider-moduleDivider__dL3Vg";
var _4 = "ProfileUserInfoItemCard-modulefooter__U008L";
var _5 = "ProfileUserInfoItemCard-moduleheader__nrS00";
var _6 = "ProfileUserInfoItemCard-moduleheaderInfo__c0lI6";
var _7 = "ProfileUserInfoItemCard-moduleheaderMain__DnHKY";
var _8 = "ProfileUserInfoItemCard-moduleloader__KTtF6";
var _9 = "ProfileUserInfoItemCard-moduleloaderIcon__ukSmj";
var _a = "ProfileUserInfoItemCard-modulename__k1Cfn";
var _b = "ProfileUserInfoItemCard-moduleopenProfileButton__RqLFP";
var _c = "ProfileUserInfoItemCard-modulestatusTag__XERd7";
export { _1 as "card", _2 as "contacts", _3 as "divider", _4 as "footer", _5 as "header", _6 as "headerInfo", _7 as "headerMain", _8 as "loader", _9 as "loaderIcon", _a as "name", _b as "openProfileButton", _c as "statusTag" }
